import api from "@/api/api";
import { ApiResponse } from "@/types/api.type";
import { ProfileFormSchema, ProfileType } from "../../../types/api/user/profile.type";

/**
 * fetchProfile
 *
 * دریافت اطلاعات پروفایل کاربر.
 *
 * @returns Promise<ProfileType>
 */
export const fetchProfile = async (): Promise<ProfileType> => {
  const res = await api.get<ApiResponse<ProfileType>>(`20card/api/user/profile`);
  return res.data.data;
};


export const fetchProfilePazirande = async (): Promise<ProfileType> => {
  const res = await api.get<ApiResponse<ProfileType>>(`20card/api/pazirande/profile`);
  return res.data.data;
};


/**
 * updateProfile
 *
 * بروزرسانی اطلاعات پروفایل کاربر.
 *
 * @param formData داده‌های فرم پروفایل
 * @returns Promise<ApiResponse<null>>
 */
export const updateProfile = async (formData: ProfileFormSchema): Promise<ApiResponse<null>> => {
  const res = await api.put<ApiResponse<null>>("20card/api/user/update-profile",
    formData
  );
  return res.data;
};

/**
 * postCheckUserBirthday
 *
 * بررسی تاریخ تولد کاربر.
 *
 * @param data اطلاعات کاربر برای بررسی تولد
 * @returns Promise<any>
 */
export const postCheckUserBirthday = async (data: any) => {
  const response = await api.post(`20card/api/user/check-user-birthday`, data);
  return response.data;
};
